import React, { useEffect, useState } from 'react'
import AdminAppBar from '../adminComponents/AdminAppBar'
import FilterContainer from './FilterContainer'
import ActionTool from './ActionTool'
import Select from "react-select";

import { useLocation, useNavigate } from 'react-router-dom'
import InterestedTagService from '../Services/InterestedTagService'
import teamService from '../Services/TeamService'
import { showErrorToast } from '../Constant/Notification'

const ReAssignLead = () => {
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  const location = useLocation();
  const { statusId, count, filteredLeadCount ,leadIds } = location.state || {};
  console.log(leadIds)
  const [totalCount, setTotalCount]= useState(count)
  const [currentstatusId, setCurrentStatusId]= useState(statusId)
    const [selectedTeam, setSelectedTeam] = useState('')
    const [teams, setTeams] = useState([]);
    const [interestedTags, setInterestedTags] = useState([]);
      const [interestedTagOption, setInterestedTagOption] = useState([]);
        const [selectedUser, setSelectedUser] = useState('')
        const [users, setUsers] = useState([]);
          const [menuOpen, setMenuOpen] = useState(false);

            const [startDate, setStartDate] = useState("");
            const [endDate, setEndDate] = useState("");
              const [loading, setLoading] = useState(false)






          const handleChange = (selectedOptions) => {
            setInterestedTags(selectedOptions);
          };  const handleBack = () => {
    if(userRole === "Admin"){

      navigate("/admin/lead-db");
      }else if (userRole === "CMO"){

        navigate('/cmo/lead-db')
      }
  };


  useEffect(() => {
    (async () => {
      try {
        const response = await InterestedTagService.fetchInterestedTag();
        const data = response.data;
        // setInterestedTags();
        let optionsArray = [];
        data.forEach((item) => {
          optionsArray.push({ value: item.id, label: item.name });
        });
        setInterestedTagOption(optionsArray);
      } catch (error) {
        showErrorToast(error.response.data);
      }

      try {
        const response = await teamService.fetchTeams();
        const data = response.data;
        console.log(data)
        setTeams(data);
      } catch (error) {
        console.error("Error fetching teams:", error);
        // Handle error if needed
      }



    })();
  }, []);


  useEffect(() => {
    const fetchUsersByTeam = async () => {
      if (selectedTeam) {
        console.log(selectedTeam)
        try {
          const response = await teamService.getTeamData(selectedTeam); // Pass selectedTeam
          const data = response.data;
          console.log(data)
          const combinedUsers = [
            ...data.BOD.map(bod => ({ name: bod.name, id: bod.id })),
            { name: data.MD.name, id: data.MD.id },
            ...data.members.map(member => ({ name: member.name, id: member.id }))
          ];

          setUsers(combinedUsers);
        console.log(users)

        } catch (error) {
          console.error("Error fetching users by team:", error);
          showErrorToast("Error fetching users");
        }
      }
    };

    fetchUsersByTeam(); // Call function when team changes
  }, [selectedTeam]);

  const formatToDDMMYYYY = (date) => {
    const [yyyy, mm, dd] = date.split('-');
    return `${mm}-${dd}-${yyyy}`;
  };
  const handleSubmit =async () => {
    console.log("handleSubmit called");
    // Check if startDate, endDate, and selectedTeam are provided
    if (!startDate) {
      showErrorToast("Please select a start date.");
      return;
    }

    if (!endDate) {
      showErrorToast("Please select an end date.");
      return;
    }
    const formattedStartDate = formatToDDMMYYYY(startDate);
      const formattedEndDate = formatToDDMMYYYY(endDate);

    if (!selectedTeam) {
      showErrorToast("Please select a team.");
      return;
    }

    const interestedTagIds = interestedTags.map(tag => tag.value);

    const filterData = {
      status: statusId,
      teamId: selectedTeam,
      membersId: selectedUser || null,
      startDate:formattedStartDate,
      endDate:formattedEndDate,
      interestedTagId:interestedTagIds,
    };
    setLoading(true)
  try{
    const response = await ReAssignLead.getReAssignCount(filterData)
    const data = response.data
    const reAssignLeadsId = data.reAssignLeads;
    // if(userRole === "Admin"){
    //   navigate("/admin/reassign-lead", {state: {leadIds:reAssignLeadsId, filteredLeadCount: data.count}})
    // }else if(userRole === "CMO"){

    //   navigate("/cmo/reassign-lead", {state: {leadIds:reAssignLeadsId, filteredLeadCount: data.count}})

    // }

  }catch(error){
    showErrorToast(error.response);

  }finally{
    setLoading(false)
  }
    // console.log("Filter data to be submitted:", filterData);
  }
  return (
    <div className=' bg-appGrayBackground '>
    <AdminAppBar/>
    <div className='pb-4 pt-28 mx-8' >
      <div className='flex gap-4 items-center ' >
      <div className="">
          <svg
            onClick={handleBack}
            className=" cursor-pointer "
            width="20"
            height="34"
            viewBox="0 0 22 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
              fill="#399E79"
            />
          </svg>
        </div>
       {currentstatusId === "PdCEXW0VIoVviuqvjdWc"?(
          <div className="font-semibold md:mx-0 cursor-default  lg:mx-6 md:text-2xl mx-14 lg:text-4xl ">
              Retry Suitable Leads ({totalCount})
            </div>
       ):currentstatusId === "VH26wB3VgVXBzoBJiqml"?( <div className="font-semibold md:mx-0 cursor-default  lg:mx-6 md:text-2xl mx-14 lg:text-4xl ">
        Not Interested Leads ({totalCount})
      </div> ):statusId === "yUuWlPRZEosdOeLzyL0f"?(<div className="font-semibold md:mx-0 cursor-default  lg:mx-6 md:text-2xl mx-14 lg:text-4xl ">
        Unanswered Leads ({totalCount})
      </div>):currentstatusId === "8337Bve50LqwfrkveUrY"?(
        <div className="font-semibold md:mx-0 cursor-default  lg:mx-6 md:text-2xl mx-14 lg:text-4xl ">
        Deal Lost Leads ({totalCount})
      </div>
      ):currentstatusId=== "L0CTrn0qwWlHWvq2gXDm"?(
        <div className="font-semibold md:mx-0 cursor-default  lg:mx-6 md:text-2xl mx-14 lg:text-4xl ">
    Fresh Leads ({totalCount})
      </div>
      ):currentstatusId=== "Auf9SQFhiKF7WRM9ZiTA"?(
        <div className="font-semibold md:mx-0 cursor-default  lg:mx-6 md:text-2xl mx-14 lg:text-4xl ">
    Follow Up Leads ({totalCount})
      </div>
      ) : ""}


      </div>

      {/* <div className='mx-14 flex gap-8 mt-10'>
      <div className='text-center  lg:text-[25px] rounded-md shadow-md pt-6  p-5 bg-[#FFF]'>
          <p className='text-3xl font-medium mb-2'>{totalCount}</p>

          {currentstatusId === "PdCEXW0VIoVviuqvjdWc"?(

          <p className='font-medium'>Total Retry Suitable Leads</p>

          ):currentstatusId ==="VH26wB3VgVXBzoBJiqml"?(

          <p className='font-medium'>Total Not Interested Leads</p>

          ):currentstatusId === "yUuWlPRZEosdOeLzyL0f"?(
          <p className='font-medium'>Total Unanswered Leads</p>

          ):currentstatusId === "8337Bve50LqwfrkveUrY"?(
          <p className='font-medium'>Total Deal Lost Leads</p>

          ):currentstatusId === "L0CTrn0qwWlHWvq2gXDm"?(
            <p className='font-medium'>Total Fresh Leads</p>

            ):""
        }
        </div>


      </div>  */}
       <div className='flex gap-10 mx-14 mt-16'>

      <FilterContainer statusId={statusId}   />
      <ActionTool filteredLeadCount={filteredLeadCount} leadId={leadIds}/>
</div>




    </div>
    </div>
  )
}

export default ReAssignLead
